import * as React from "preact";
import { FunctionComponent } from "preact";

import { ITableColumns } from "../Table";

interface ITableBody {
  columns: ITableColumns[];
  data: any;
  currentFilter: string;
}

const formatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const TableBody: FunctionComponent<ITableBody> = ({ columns, data, currentFilter }) => {
  return (
    <tbody>
      {data.map((data) => {
        return (
          <tr key={data.id}>
            {columns.map(({ accessor, type, hiddenOn, shownOn }) => {
              let tData = data[accessor] ? data[accessor] : "";
              const isHidden = currentFilter == hiddenOn || (shownOn != null && currentFilter != shownOn);
              if (type === "currency") {
                tData = formatter.format(tData);
              }
              if (!isHidden) {
                return <td key={accessor}>{tData}</td>;
              }
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
